import experiment from 'experiment';
import type { BaseDragPlugin } from '#packages/rEditor';

import { getAllSlotsForComponent } from './utils';
import { openSlotIfExists, showSlotIfExists } from './showSlotIfExists';
import * as store from './slotOpenerStore';

/**
 * When a component is dragged between two others - creates a gap between them to make space and avoid overlap. Only for mobile.
 */
export const createSlotOpenerDragPlugin = (): BaseDragPlugin => ({
  init: ({ hooks, pluginFactoryScope }) => {
    const { editorAPI } = pluginFactoryScope;

    const isInHeaderFooter = !!editorAPI.sections.getClosestHeaderFooter(
      pluginFactoryScope.selectedComp[0],
    );

    if (
      isInHeaderFooter ||
      !editorAPI.isMobileEditor() ||
      !experiment.isOpen('se_mobileStageNewBehaviour')
    ) {
      return;
    }

    hooks.onDragStart.tap(() => {
      const allSlots = getAllSlotsForComponent(
        editorAPI,
        pluginFactoryScope.selectedComp,
      );

      store.setAllSlotsInContainer(allSlots);
    });

    hooks.updateLayout.tap(({ currentMousePosition }) => {
      showSlotIfExists(editorAPI, currentMousePosition);
    });

    hooks.endDrag.tap(() => {
      const { selectedComp } = pluginFactoryScope;

      if (!selectedComp) {
        return;
      }

      openSlotIfExists(editorAPI, selectedComp);
    });
  },
});
